import { useState, useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { API_URL } from '../config';

/**
 * Custom hook to fetch customer metadata from Stripe
 * @returns {Object} Customer metadata and loading state
 */
const useCustomerMetadata = () => {
  const { isAuthenticated, getAccessTokenSilently } = useAuth0();
  const [metadata, setMetadata] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchMetadata = async () => {
      if (!isAuthenticated) {
        setMetadata(null);
        return;
      }

      setLoading(true);
      setError(null);

      try {
        console.log('Fetching customer metadata...');
        
        // Get the access token
        const token = await getAccessTokenSilently();
        console.log('Got access token');
        
        // Fetch customer metadata
        console.log(`Calling API: ${API_URL}/api/customer-metadata`);
        const response = await fetch(`${API_URL}/api/customer-metadata`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        console.log('API response status:', response.status);
        
        if (!response.ok) {
          const errorText = await response.text();
          console.error('API error response:', errorText);
          throw new Error(`Failed to fetch customer metadata: ${response.status} ${response.statusText} - ${errorText}`);
        }

        const data = await response.json();
        console.log('Customer metadata:', data);
        setMetadata(data);
      } catch (err) {
        console.error('Error fetching customer metadata:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchMetadata();
  }, [isAuthenticated, getAccessTokenSilently]);

  return { metadata, loading, error };
};

export default useCustomerMetadata;
